import { RootState } from '@checkout/state';
import { debounce } from 'lodash-es';
import * as React from 'react';
import { ChangeEvent } from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import messages from '../../../i18n/base-en';
import { setOrderMessageText, toggleOrderMessage, updatePaymentFieldsRequest } from '../../../reducers/checkout';
import { InputBox, Section, TextArea } from './../../presentational';
import * as Styles from './OrderMessage.scss';

interface IOwnProps {}

interface IConnectedProps {
  additionalNotes: {
    visible: boolean;
    text: string;
  };
}

interface IConnectetDispatchProps {
  updatePaymentFieldsRequest: typeof updatePaymentFieldsRequest;
  toggleOrderMessage: typeof toggleOrderMessage;
  setOrderMessageText: typeof setOrderMessageText;
}

interface IOwnState {
  isActive: boolean;
  value: string;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class OrderMessage extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    isActive: this.props.additionalNotes.visible,
    value: this.props.additionalNotes.text,
  };

  toggleActive = () => {
    this.props.toggleOrderMessage({ isActive: !this.props.additionalNotes.visible });
  }

  handleFieldChange =  debounce((value: string) => {
    const { updatePaymentFieldsRequest: updatePaymentField } = this.props;

    this.props.setOrderMessageText({ value });
    updatePaymentField({ additionalNotes: value });
  }, 700);

  handleChange = (event: ChangeEvent<any>) => {
    const { value } = event.target;

    this.setState({
      value,
    });

    this.handleFieldChange(value);
  }

  render() {
    const { value } = this.state;
    const { intl, additionalNotes } = this.props;
    const { formatMessage } = intl;

    return (
      <Fragment>
        <InputBox
          type="checkbox"
          id="cartFieldsData.additionalNotes.visible"
          name="cartFieldsData.additionalNotes.visible"
          checked={additionalNotes.visible}
          value={additionalNotes.visible}
          variant="toggle"
          onChange={this.toggleActive}
          label={formatMessage(messages.order_message_group_title)}
        />
        {additionalNotes.visible && (
          <div className={Styles.wrapper}>
            <Section blockFor="additionalNotes" spacingBottom="no">
              <TextArea
                id="cartFieldsData.additionalNotes.text"
                name="cartFieldsData.additionalNotes.text"
                value={value}
                onChange={this.handleChange}
                placeholder={formatMessage(messages.additional_notes_placeholder)}
                label={formatMessage(messages.additional_notes_label)}
              />
            </Section>
          </div>
        )}
      </Fragment>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, {}>(
    (state: RootState) => ({
      additionalNotes: state.checkout.cartFieldsData.additionalNotes
    }),
    {
      updatePaymentFieldsRequest,
      toggleOrderMessage,
      setOrderMessageText,
    },
  )
)(OrderMessage);
